import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

import queryString from 'query-string';

import { useGrid } from '@Components/Grid';
import history from '@Utils/history';

export default function useSearchConfiguration() {
  const { search } = useLocation()
  const { state: { setSearch } } = useGrid()

  useEffect(() => {
    const query = queryString.parse(search)
    if (query?.configure) {
      const { id, jobId } = JSON.parse(atob(query.configure))
      setSearch(id || jobId)
      history.replace({ search: '' })
    }
  }, [search, setSearch])
}
